console.log('--- EXECUTING SHARED MODULE FILE ---')
import {AppBarModule, NavigationModule} from "@progress/kendo-angular-navigation";
import {ButtonsModule, ButtonModule} from "@progress/kendo-angular-buttons";
import {CardModule} from "@progress/kendo-angular-layout";
import {
  CellTemplateDirective,
  ColumnComponent,
  DataBindingDirective, DetailTemplateDirective,
  FilterCellTemplateDirective,
  FocusableDirective,
  FooterTemplateDirective, GridModule,
  NoRecordsTemplateDirective
} from "@progress/kendo-angular-grid";
import {CommonModule} from '@angular/common';
import {ConvertDateSubmittedPipe} from "./pipes/convert-date-submitted.pipe";
import {ConvertDobPipe} from "./pipes/convert-dob.pipe";
import {ConvertUtcPipe} from "./pipes/convert-utc.pipe";
import {ConvertUtcNoTimePipe} from "./pipes/convert-utc-no-time.pipe";
import {DateInputsModule} from "@progress/kendo-angular-dateinputs";
import {DateRangeFilterCellComponent} from "./filters/date-range-filter.component";
import {DialogModule, WindowModule} from "@progress/kendo-angular-dialog";
import {DropDownsModule} from "@progress/kendo-angular-dropdowns";
import {FaConfig, FaIconLibrary, FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import {fas} from "@fortawesome/free-solid-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FormStatusFilterComponent} from "./filters/form-status-filter.component";
import {FormStatusPipe} from "./pipes/form-status.pipe";
import {FormTypeFilterComponent} from "./filters/form-type-filter.component";
import {AiReviewFilterComponent} from "./filters/ai-review-filter.component";
import {FormTypePipe} from "./pipes/form-type.pipe";
import {GenderPipe} from "./pipes/gender.pipe";
import {GridComponent} from "@progress/kendo-angular-grid";
import {IconsModule} from "@progress/kendo-angular-icons";
import {IndicatorsModule, KENDO_INDICATORS} from "@progress/kendo-angular-indicators";
import {InputsModule, KENDO_INPUTS, SwitchModule} from "@progress/kendo-angular-inputs";
import {KENDO_MENUS} from '@progress/kendo-angular-menu';
import {KENDO_LABELS, LabelModule} from "@progress/kendo-angular-label";
import {LayoutModule} from "@progress/kendo-angular-layout";
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {OrganizationFilterComponent} from "./filters/organization-filter.component";
import {PatientFormComponent} from './components/patient-form/patient-form.component';
import { PatientMatchesComponent } from './components/patient-matches/patient-matches.component';
import { PatientReviewComponent } from './components/patient-review/patient-review.component';
import {PdfViewerModule} from "ng2-pdf-viewer";
import {PhoneFormatPipe} from "./pipes/phone-format.pipe";
import {ProgressBarModule} from "@progress/kendo-angular-progressbar";
import {TooltipModule} from "@progress/kendo-angular-tooltip";
import {TreeViewModule} from "@progress/kendo-angular-treeview";
import { NgModule } from '@angular/core';
import {UploadsModule} from "@progress/kendo-angular-upload";
import { PatientFormsPanelComponent } from './components/patient-forms-panel/patient-forms-panel.component';
import { RejectReasonsFormComponent } from './components/reject-reasons-form/reject-reasons-form.component';
import { HcpoaAgentComponent } from './components/hcpoa-agent/hcpoa-agent.component';
import { ImmediateMarkComponent } from './components/immediate-mark/immediate-mark.component';
const FILTERS = [
  DateRangeFilterCellComponent,
  FormStatusFilterComponent,
  FormTypeFilterComponent,
  OrganizationFilterComponent,
  AiReviewFilterComponent
];
const PIPES = [
  ConvertDateSubmittedPipe,
  ConvertDobPipe,
  ConvertUtcPipe,
  ConvertUtcNoTimePipe,
  FormStatusPipe,
  FormTypePipe,
  GenderPipe,
  PhoneFormatPipe
];

const FORM_MODULES = [
  FormsModule,
  ReactiveFormsModule
];

const KENDO_MODULES = [
  AppBarModule,
  ButtonModule,
  ButtonsModule,
  CardModule,
  DateInputsModule,
  DialogModule,
  DropDownsModule,
  GridModule,
  IconsModule,
  IndicatorsModule,
  InputsModule,
  LabelModule,
  LayoutModule,
  NavigationModule,
  ProgressBarModule,
  SwitchModule,
  TooltipModule,
  TreeViewModule,
  WindowModule,
  UploadsModule,
  KENDO_INDICATORS,
  KENDO_MENUS,
  KENDO_INPUTS,
  KENDO_LABELS,
];
const COMPONENTS = [
  RejectReasonsFormComponent,
  // PatientFormComponent,
  PatientMatchesComponent,
  PatientReviewComponent,
  PatientFormsPanelComponent,
  HcpoaAgentComponent,
  ImmediateMarkComponent
]
COMPONENTS.forEach((comp, index) => {
  if (!comp) console.error(`Component at index ${index} is UNDEFINED!`);
});
@NgModule({
  declarations: [
    FILTERS,
    PIPES,
    PatientFormComponent,
    PatientMatchesComponent,
    PatientReviewComponent,
    PatientFormsPanelComponent,
    RejectReasonsFormComponent,
    HcpoaAgentComponent,
    ImmediateMarkComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FORM_MODULES,
    KENDO_MODULES
  ],
  exports: [
    FILTERS,
    PIPES,
    FORM_MODULES,
    KENDO_MODULES,
    PatientFormComponent,
    PatientMatchesComponent,
    PatientReviewComponent,
    PatientFormsPanelComponent,
    RejectReasonsFormComponent,
    HcpoaAgentComponent,
    ImmediateMarkComponent
  ]
})
export class SharedModule {
  constructor(library: FaIconLibrary, faConfig: FaConfig) {
    // Add FontAwesome icon packs
    library.addIconPacks(); // fas, far, etc. Add your packs here
  }
}

